// const BORDER_COLOR = ["", "#9400D3", "#3232FF", "#FF28A7", "#20B2AA","","","","","","","","","","","",];
const BORDER_COLOR = {
    "1": "#9400D3",
    "2": "#3232FF",
    "3": "#FF28A7",
    "4": "#20B2AA",
    "20": "#C8852C"
}

export { BORDER_COLOR }